/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import {
  Menu,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import { StyledSubHeader, StyledItemText } from "./styles";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

export const AddMobileAppUsersMenu = ({
  anchorEl,
  onClose,
  onAddEmployee,
  onAddNetworkGuest,
  onBulkAddEmployees,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      data-testid="add-mobile-app-users-menu"
    >
      <StyledSubHeader>MANUAL CREATION</StyledSubHeader>
      <MenuItem onClick={onAddEmployee} data-testid="add-employee-menu-item">
        <ListItemIcon>
          <PersonAddAltOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <StyledItemText>Add employee</StyledItemText>
      </MenuItem>
      <MenuItem onClick={onAddNetworkGuest} data-testid="add-network-guest-menu-item">
        <ListItemIcon>
          <PersonAddAltOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <StyledItemText>Add network guest</StyledItemText>
      </MenuItem>
      <StyledSubHeader>BULK CREATION</StyledSubHeader>
      <MenuItem onClick={onBulkAddEmployees} data-testid="bulk-add-employees-menu-item">
        <ListItemIcon>
          <FileUploadOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <StyledItemText>Bulk add employees</StyledItemText>
      </MenuItem>
    </Menu>
  );
};
